import { makeEntityOptionsRepository } from 'src/data/repositories/common/entity-options/entity-options-repository-factory';
import { makeLogService } from 'src/data/services/common/log/log/log-service-factory';
import { LoadEntityOptionsUseCase } from './load-entity-options-use-case';

let loadEntityOptionsUseCase: LoadEntityOptionsUseCase;

export function makeLoadEntityOptionsUseCase(): LoadEntityOptionsUseCase {
  if (!loadEntityOptionsUseCase) {
    loadEntityOptionsUseCase = new LoadEntityOptionsUseCase(
      makeLogService(),
      makeEntityOptionsRepository(),
    );
  }

  return loadEntityOptionsUseCase;
}
